import dayjs from 'dayjs';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import 'dayjs/locale/ar';

// Enables localized format tokens (L, LL, LT, ...) used across the app.
// dayjs does not support these without the plugin, unlike moment (see the
// pnpm/dayjs migration). Without it, format('L') returns the literal "L".
dayjs.extend(localizedFormat);

export default dayjs;
